<template>
  <main-layout>
    <div class="buttons is-pulled-right">
      <router-link
        class="button is-success is-small"
        :to="{ name: 'estimates.create' }"
      >
        Nuovo
      </router-link>
    </div>
    <h1 class="title">Preventivi</h1>

    <api-table :fetch-action="fetch" :items-getter="getter">
      <template slot-scope="props">
        <b-table-column field="id" label="ID" width="40" sortable numeric>
          {{ props.row.id }}
        </b-table-column>

        <b-table-column field="name" label="Nome" sortable>
          <b>
            <router-link
              :to="{ name: 'estimates.show', params: { id: props.row.id } }"
            >
              {{ props.row.name }}
            </router-link>
          </b>
        </b-table-column>

        <b-table-column field="customer_name" label="Cliente" sortable>
          <router-link
            :to="{ name: 'customers.show', params: { id: props.row.customer } }"
          >
            {{ props.row.customer_name }}
          </router-link>
        </b-table-column>

        <b-table-column field="is_closed" label="Chiuso" sortable>
          <b-checkbox disabled :value="props.row.is_closed"></b-checkbox>
        </b-table-column>

        <b-table-column field="modified" label="Modificato" sortable centered>
          <b-tooltip
            :label="new Date(props.row.modified).toLocaleString('it-IT')"
            type="is-dark"
            position="is-right"
            animated
          >
            <span class="tag is-light">
              <timeago :datetime="props.row.modified" :auto-update="60" />
            </span>
          </b-tooltip>
        </b-table-column>

        <b-table-column label="Azioni" width="300">
          <div class="buttons">
            <button
              class="button is-small is-warning"
              @click="duplicate(props.row.id)"
            >
              x2
            </button>
            <router-link
              :to="{ name: 'estimates.print', params: { id: props.row.id } }"
              class="button is-small"
              target="_blank"
            >
              <span>Stampa</span>
            </router-link>
            <router-link
              :to="{
                name: 'estimates.printSecurity',
                params: { id: props.row.id }
              }"
              class="button is-small"
              target="_blank"
            >
              <span>S</span>
            </router-link>
            <router-link
              :to="{
                name: 'estimates.printSecurity2',
                params: { id: props.row.id }
              }"
              class="button is-small"
              target="_blank"
            >
              <span>S2</span>
            </router-link>
            <delete-button
              :id="props.row.id"
              :submit-action="destroy"
              @done="fetch()"
            />
            <!-- <router-link
              :to="{ name: 'estimates.edit', params: { id: props.row.id }}"
              class="button is-small">
              <span class="icon">
                <i class="fas fa-edit" />
              </span>
              <span>Modifica</span>
            </router-link> -->
          </div>
        </b-table-column>
      </template>
    </api-table>
  </main-layout>
</template>

<script>
import { get, call } from "vuex-pathify"

import MainLayout from "@/layouts/Main"
import DeleteButton from "@/components/DeleteButton"
import EstimateProxy from "@/proxies/EstimateProxy"

export default {
  components: {
    MainLayout,
    DeleteButton
  },
  data() {
    return {
      search: ""
    }
  },
  methods: {
    fetch: call("estimates/all"),
    getter: get("estimates/estimates"),
    destroy: call("estimates/destroy"),
    async duplicate(id) {
      let duplicate = await new EstimateProxy().duplicate(id)
      this.$toast.open({
        message: "Preventivo duplicato con successo",
        type: "is-success"
      })
      this.$router.push({
        name: "estimates.show",
        params: { id: duplicate.id }
      })
    }
  }
}
</script>
